import script from "./MessageListDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageListDetails.vue?vue&type=script&setup=true&lang=js"

import "./MessageListDetails.vue?vue&type=style&index=0&id=52b46d3c&lang=css"

const __exports__ = script;

export default __exports__